import store from '@/store/store';

export default class LoadingController {
    public static STORE_MUTATION_VISIBILITY = 'setLoadingVisibility';
    public static STORE_MUTATION_IS_FORCE_HIDDEN = 'setLoadingIsForceHidden';
    public static STORE_MUTATION_APPENDING_TEXT = 'setLoadingAppendedText';
    public static STORE_MUTATION_PROGRESS_PERCENTAGE = 'setLoadingProgressPercentage';
    public static STORE_MUTATION_IS_INDETERMINATE = 'setLoadingIsIndeterminate';
    public static STORE_MUTATION_CANCEL_VISIBLE = 'setLoadingCancelVisible';

    /**
     * Função destinada ao controle das variáveis de Popup armazenadas na store
     * 
     * @param boolean visibility
     */
    public static controlLoginViaStore(visibility: boolean) {
        store.commit(this.STORE_MUTATION_VISIBILITY, visibility);
    }

    public static showLoading() {
        this.controlLoginViaStore(true);
    }

    public static hideLoading() {
        this.controlLoginViaStore(false);
    }

    public static forceHideLoading() {
        store.commit(this.STORE_MUTATION_IS_FORCE_HIDDEN, true);
    }

    public static cancelForceHideLoading() {
        store.commit(this.STORE_MUTATION_IS_FORCE_HIDDEN, false);
    }

    public static setDefaultLoadingBehavior() {
        this.setIndeterminateLoading();
        this.unsetLoadingAppendedText();
        this.setLoadingCancelInvisible();
    }

    public static setLoadingAppendedText(text: string) {
        store.commit(this.STORE_MUTATION_APPENDING_TEXT, text);
    }

    public static unsetLoadingAppendedText() {
        store.commit(this.STORE_MUTATION_APPENDING_TEXT, null);
    }

    public static setIndeterminateLoading() {
        store.commit(this.STORE_MUTATION_PROGRESS_PERCENTAGE, 0);
        store.commit(this.STORE_MUTATION_IS_INDETERMINATE, true);
    }

    public static setProgressLoading(percentage: number = 0) {
        store.commit(this.STORE_MUTATION_PROGRESS_PERCENTAGE, percentage);
        store.commit(this.STORE_MUTATION_IS_INDETERMINATE, false);
    }

    public static updateProgressLoading(percentage: number) {
        store.commit(this.STORE_MUTATION_PROGRESS_PERCENTAGE, percentage);
    }

    public static setLoadingCancelVisible() {
        store.commit(this.STORE_MUTATION_CANCEL_VISIBLE, true);
    }

    public static setLoadingCancelInvisible() {
        store.commit(this.STORE_MUTATION_CANCEL_VISIBLE, false);
    }
}